export default __webpack_public_path__ + "static/media/mumbai.ffb11b83.png";